import React from "react";

import { Button } from "../../../../components/react/buttons/Button";

interface Props {
	canReset: boolean;
	label: string;
	onReset: () => void;
}

export const Header = ({ canReset, label, onReset }: Props): React.JSX.Element => (
	<div className="mb-2 flex items-center justify-between">
		<p className="m-0 font-medium text-gray-800">{label}</p>
		{canReset && (
			<Button
				className="p-0 text-xs!"
				onClick={() => {
					onReset();
				}}
				size="tiny"
				type="link"
			>
				Reset
			</Button>
		)}
	</div>
);
